import { Typography } from '@mui/material';
import { set } from 'lodash';
import React from 'react';

const SOURCE_URL = 'https://pub-80c25841bf1e4cbda246ab1b42798500.r2.dev/';

export const GifPlayer = ({
  caption,
  url,
  sourceId,
}: {
  caption: string;
  url?: string;
  sourceId?: string;
}) => {
  const sources_list = ['av1', 'vp9', 'x264'].map((codec) => {
    return {
      src: `${SOURCE_URL}${sourceId}/${sourceId}.${codec}.mp4`,
      codec: codec.startsWith('av1') ? 'av01.0.05M.08' : codec,
    };
  });

  // add ref for video
  const videoRef = React.useRef<HTMLVideoElement>(null);

  React.useEffect(() => {
    if (sourceId) {
      if (window.navigator.userAgent.toLowerCase().includes('edg')) {
        // remove av1, edge is buggy with it
        videoRef.current?.setAttribute('src', sources_list[2].src);
      }
    }
  }, [sourceId]);

  return (
    <>
      <video width="100%" controls ref={videoRef}>
        <track kind="captions" title={caption} />
        {url && <source src={url} type="video/webm" />}
        {sourceId &&
          sources_list.map(({ src, codec }) => (
            <source key={codec} src={src} type={`video/mp4; codecs=${codec}`} />
          ))}
        No supported video found
      </video>
      <Typography
        variant="caption"
        style={{ display: 'flex', justifyContent: 'center', fontSize: '0.7em' }}
      >
        {caption}
      </Typography>
    </>
  );
};
